import React from 'react';

// Import Types overviews
import ClubDealOverview from './types/ClubDealOverview';
import PrivateFinancingOverview from './types/PrivateFinancingOverview';
import RealEstateOverview from './types/RealEstateOverview';
import GenericOverview from './types/GenericOverview';

// Import Tabs wrappers (we will create these later)
import TransactionParticipants from './tabs/TransactionParticipants';
import TransactionDocuments from './tabs/TransactionDocuments';
import TransactionFlows from './tabs/TransactionFlows';
import TransactionHistory from './tabs/TransactionHistory';
import TransactionAccess from './tabs/TransactionAccess';

import TransactionSidebar from './TransactionSidebar';

export default function TransactionTabContent({ activeTab, transaction, onRefresh }) {
  if (activeTab === 'overview') {
    let OverviewComponent = GenericOverview;
    switch (transaction.transactionType) {
      case 'CLUB_DEAL':
        OverviewComponent = ClubDealOverview;
        break;
      case 'PRIVATE_FINANCING':
      case 'CORPORATE_DEBT':
        OverviewComponent = PrivateFinancingOverview;
        break;
      case 'REAL_ESTATE':
        OverviewComponent = RealEstateOverview;
        break;
      default:
        OverviewComponent = GenericOverview;
    }

    return (
      <div className="grid grid-cols-1 gap-6 xl:grid-cols-12">
        <main className="space-y-6 xl:col-span-8">
          <OverviewComponent transaction={transaction} />
          {/* TransactionStructure could be added here later */}
        </main>
        <aside className="space-y-6 xl:col-span-4">
          <TransactionSidebar transaction={transaction} />
        </aside>
      </div>
    );
  }

  // Other tabs
  switch (activeTab) {
    case 'participants':
      return <TransactionParticipants transaction={transaction} onRefresh={onRefresh} />;
    case 'documents':
      return <TransactionDocuments transaction={transaction} onRefresh={onRefresh} />;
    case 'flows':
      return <TransactionFlows transaction={transaction} onRefresh={onRefresh} />;
    case 'history':
      return <TransactionHistory transaction={transaction} onRefresh={onRefresh} />;
    case 'access':
      return <TransactionAccess transaction={transaction} onRefresh={onRefresh} />;
    default:
      return null;
  }
}
